import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1400To1499Service {

  constructor() { }
}
